export default {"src":"/_next/static/media/Products.3051ac0e.svg","height":36,"width":33,"blurWidth":0,"blurHeight":0};